/**
 * Authentication Configuration
 * 
 * This file contains settings related to authentication,
 * including session timeout durations.
 */

// Session timeout settings in milliseconds
export const SESSION_CONFIG = {
  // Total inactivity time before logging out (30 minutes)
  INACTIVITY_TIMEOUT: 30 * 60 * 1000,
  
  // Warning time before timeout (2 minutes)
  WARNING_BEFORE_TIMEOUT: 2 * 60 * 1000,
  
  // Events to track for user activity
  ACTIVITY_EVENTS: ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'],
  
  // Development mode - set to true to use shorter timeouts for testing
  DEV_MODE: false
};

// If in development mode, use shorter timeouts for testing
if (SESSION_CONFIG.DEV_MODE) {
  SESSION_CONFIG.INACTIVITY_TIMEOUT = 60 * 1000; // 1 minute
  SESSION_CONFIG.WARNING_BEFORE_TIMEOUT = 30 * 1000; // 30 seconds
}

export default SESSION_CONFIG; 